import { confirmOrderAction } from "./confirmOrderAction";

export const confirmPayment = (
  accessCode: string,
  accessToken: string,
  orderId: string
) => confirmOrderAction(accessCode, accessToken, orderId, "confirmPayment");
